var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.333h512V426.67H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M413.681 293.097v7.421h-59.363v-7.421h-22.26v29.682h14.841v7.419h74.202v-7.419h14.841v-29.682z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M332.058 181.793v81.623c0 39.759 51.942 51.942 51.942 51.942s51.942-12.182 51.942-51.942v-81.623H332.058z",
  fill: "#338af3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M383.997 242.675c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986 0-12.986-11.873-25.973-11.873zm0-41.59c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986 0-12.986-11.873-25.973-11.873z",
  fill: "#f3f3f3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.827v40.827h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.827V85.333h55.652v48.573l87.43-48.573z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
  fill: "#d80027"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
  fill: "#d80027"
})));

export default SvgFk;